import { FC } from "react";
import { useDispatch } from "react-redux";

import __ from "web/Layout/Translations";

import CopyIcon from "web/assets/icons/copy.svg";

import { PropsWithClasses } from "web/types/Common";

import copyCodeToClipboard from "../CodeModal/utils/copyCodeToClipboard";
import styles from "./codeLine.scss";

interface ICodeLineProps {
  label?: string;
  value: string;
  dataT1?: string;
}
const CodeLine: FC<PropsWithClasses<ICodeLineProps>> = ({
  label,
  value,
  dataT1,
  classes,
}) => {
  const dispatch = useDispatch();

  return (
    <div data-t1={dataT1} className={classes?.codeLine}>
      <div>
        {label && <span className={classes?.codeLineName}>{label}:</span>}{" "}
        <span className={classes?.codeLineValue}>{value}</span>
      </div>
      <button
        type="button"
        className={classes?.codeLineCopyButton}
        onClick={(e) => {
          copyCodeToClipboard({ dispatch, code: value });
          e.stopPropagation();
        }}
        aria-label={__("Kopiuj kod do schowka")}
      >
        <CopyIcon
          className={`${
            classes?.codeLineCopyIcon ? classes.codeLineCopyIcon : ""
          } ${styles.copyIcon}`}
        />
      </button>
    </div>
  );
};

export default CodeLine;
